import { TweenMax } from 'gsap/TweenMax';
import { DOCUMENT_ELEMENT, ROOT_ELEMENT } from '@/scripts/constants';
import toggleModal from '@/scripts/utils/toggle-modal';

export default function () {
  const ESC = 27;

  function closeModal(container, remove) {
    TweenMax.to(container, 0.8, { y: '-100%' });
    DOCUMENT_ELEMENT.classList.remove('modal-opened');
    toggleModal(DOCUMENT_ELEMENT.classList.contains('modal-opened'), '.newsletter', container);
    if (remove) {
      setTimeout(() => {
        container.remove();
      }, 2000);
    }
  }

  function openModal(scrollbar, modal) {
    TweenMax.to(modal, 0.8, { y: '0%' });
    DOCUMENT_ELEMENT.classList.add('modal-opened');
    toggleModal(DOCUMENT_ELEMENT.classList.contains('modal-opened'), scrollbar, modal);
  }

  function initModalEvents(modal) {
    const closeBtn = modal.querySelector('[data-type*="close-modal"]');
    closeBtn.addEventListener('click', () => {
      closeModal(modal, false);
    }, { once: true });
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === ESC) {
        closeModal(modal, false);
      }
    }, { once: true });
  }

  function createContainer(btn) {
    const loaderSrc = btn.dataset.loader;
    const videoSrc = btn.dataset.video;
    const checkYoutube = btn.dataset.youtube;
    const container = document.createElement('div');
    let containerInnerHtml = '';
    if (checkYoutube) {
      containerInnerHtml = `<img class="video__loader" src=${loaderSrc}/><button class="video__close" data-type="close-modal"><span class="icon-close"></span></button>${videoSrc}`;
    } else {
      containerInnerHtml = `<img class="video__loader" src=${loaderSrc}/><button class="video__close" data-type="close-modal"><span class="icon-close"></span></button><video src="${videoSrc}" autoplay="autoplay" loop="loop" controls="controls" tabindex="0">Sorry, your browser doesn't support embedded videos.</video>`;
    }
    container.classList.add('video');
    container.innerHTML = containerInnerHtml;

    ROOT_ELEMENT.appendChild(container);
    return container;
  }

  function initNewsletterModal() {
    const newsletter = document.querySelector('[data-type*="newsletter"]');
    if (!newsletter) return;

    const newsletterForm = document.querySelector('[data-type*="newsletter-form"]');
    newsletter.addEventListener('click', (e) => {
      e.preventDefault();
      openModal('.newsletter', newsletterForm);
      initModalEvents(newsletterForm);
    });
  }

  function initVideoModals() {
    const playVideoBtns = document.querySelectorAll('[data-type*="play-video"]');
    if (!playVideoBtns.length) return;

    playVideoBtns.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        const container = createContainer(this);

        e.preventDefault();
        openModal('.video', container);
        initModalEvents(container);
      });
    });
  }

  initNewsletterModal();
  initVideoModals();
}




// WEBPACK FOOTER //
// ./scripts/blocks/modals.js